module Meevo.Components.Controls {
    declare let d3: any;

    class MeevoGoalsBarChartComponent implements angular.IComponentController {

        static $inject = ['$scope'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;

        constructor(private $scope: ng.IScope) { }


        $onInit = () => {

            //console.log('inside goalsBarChart.component - this.parent =>', this.parent);

            let chartClass: string = '.'.concat(this.chartClass);
            this.goalDecimal = this.parent.goal;
            this.actualDecimal = this.parent.actual;


        }

        //createBarChart = (numGoal: number, numActual: number, id: string) => {
        //    console.log('inside createBarChart', numGoal, numActual)
        //    let width: number = 200;
        //    let height: number = 200;
        //    let thickness: number = 40;
        //    let duration: number = 1000;
        //    let foregroundColor: string = "#72b8ff";
        //    let backgroundColor: string = "#ccc";
        //    let percent: number = numActual;
        //    let margin = {
        //        top: 0,
        //        bottom: 0,
        //        left: 0,
        //        right: 0,
        //    };
        //    let groupBarPadding = .2;
        //    let individualBarPadding = 4;
        //    var color = d3.scaleOrdinal([backgroundColor, foregroundColor]);

        //    const categories = ['goals', 'actuals'];

        //    let data = [
        //        {
        //            subCategory: 'goals',
        //            value: numGoal,
        //        },
        //        {
        //            subCategory: 'actual',
        //            value: numActual,
        //        }
        //    ];
            
        //    const svg = d3.select(id);
        //    if (d3.select(id).select('svg').empty()) {
        //        svg.append('svg')
        //            .attr('class', 'bar-chart')
        //            .attr('preserveAspectRatio', 'xMinYMin meet')
        //            .attr('width', width)
        //            .attr('height', height)
        //            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        //    }
        //    else {
        //        svg.selectAll('*').remove();

        //        svg.attr('class', 'bar-chart')
        //            .attr('preserveAspectRatio', 'xMinYMin meet')
        //            .attr('width', width)
        //            .attr('height', height)
        //            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        //    }
                
        //    const x = d3.scaleBand().rangeRound([0, width]).padding(groupBarPadding);
        //    const y = d3.scaleLinear().rangeRound([height, 0]);

        //    const xAxis = d3.axisBottom(x)
        //        .tickValues([])
        //        .tickSize(0);

        //    // Chart placement
        //    svg.attr('width', width)
        //        .attr('height', height)
        //        .append('g')
        //        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')


        //    x.domain(data.map(function (d) { return d.subCategory; }));

        //    y.domain([0, d3.max(data, function (d) { return d.value; })]);

        //    // Draw x-axis
        //    svg.append('g')
        //        .attr('class', 'x axis')
        //        .attr('transform', 'translate(0, ' + height + ')')
        //        .call(xAxis)
        //        .selectAll('text')
        //        .attr('class', 'svg-category-label')

        //    // Hide label
        //    svg.selectAll('.svg-category-label')
        //        .attr('display', 'none')

        //    // Chart
        //    svg.selectAll('rect')
        //        .data(data)
        //        .enter().append('rect')
        //        .attr('class', 'bar')
        //        .attr('x', function (d) { return x(d.subCategory) })
        //        .attr('y', function (d) { return y(0) })
        //        .attr('width', x.bandwidth())
        //        .attr('height', function (d) { return height - y(0) })
        //        .attr('fill', d => color(d.subCategory))

        //    // Transition animation
        //    svg.selectAll('rect')
        //        .transition()
        //        .delay(200)
        //        .duration(1000)
        //        .attr('y', function (d) { return y(d.value) })
        //        .attr('height', function (d) { return height - y(d.value) });

        //}
    }
  

    angular.module('meevo.components.controls')
        .component('meevoGoalsBarChartComponent', <angular.IComponentOptions> {
            templateUrl: 'app/components/controls/charts/goalsBarChart/goalsBarChart.template.html',
            controller: MeevoGoalsBarChartComponent,
            controllerAs: 'vm',
            bindings: {
                chartClass: '@',
                goal: '<',
                actual: '<',
                mapFn: '='
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
    });
}